import { router } from "@smakecloud/api-client-helper";
import { list } from "../workflows/list";

export const BasicSettingsWorkflows = router({
    list,
});
